export class MockWhmcsAdapter {
    async postBillableItem(_req) {
        await new Promise((r) => setTimeout(r, 400));
        const billableId = String(20000 + Math.floor(Math.random() * 80000));
        return { billableId, postedOn: new Date().toISOString() };
    }
}
export class HttpWhmcsAdapter {
    async postBillableItem(req) {
        const res = await fetch("/api/whmcs-billable", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(req),
        });
        if (!res.ok) {
            let detail = "";
            try {
                const body = await res.json();
                detail = body?.error ?? body?.message ?? "";
            }
            catch {
                detail = await res.text().catch(() => "");
            }
            throw new Error(`WHMCS post failed (${res.status})${detail ? ` — ${detail}` : ""}. See docs/swa-managed-function.md.`);
        }
        return (await res.json());
    }
}
